const site = window.location.origin;
const productionMode = process.env.NODE_ENV === 'production';

// export const webSSO = 'https://sso.cadem.cl';
// export const API_SSO = 'https://backend-sso-xbstdiqb2a-ue.a.run.app';

export const webSSO = productionMode
    ? 'https://sso.cadem.cl' // Produccion Cloud Run
    : 'http://localhost:4500'; // Desarrollo

export const API_SSO = productionMode
    ? 'https://backend-sso-xbstdiqb2a-ue.a.run.app' // Produccion Cloud Run
    : 'http://localhost:8081'; // Desarrollo

export const API_BASE_URL_NESTJS  = productionMode
    ? 'https://backend-web-cadem-online-ba7zkvym3a-ue.a.run.app'                    
    : 'http://localhost:8080'; 

export const completeSsoRedirect = `${webSSO}/login?site=${utf8_to_b64(site)}`;
export const completeSsoLogout = `${webSSO}/logout?site=${utf8_to_b64(site)}`;

export const SIZE_FILE =  30000000;
export const API_BASE_URL = productionMode
    ? 'https://backend-web-comunidad-pyxwmvpacq-ue.a.run.app' // Produccion Cloud Run
    : 'http://localhost:5000'; // Desarrollo

function utf8_to_b64(str) {
    return window.btoa(unescape(encodeURIComponent( str )));
}